/** Pulisce la sessione mantenendo lingua, flag webview app, cache città e promo Home. */
import { HOME_PERSISTED_PROMO_KEYS } from 'Containers/Home/utils/homePromoStorage';
import { SCHEDULER_PERSISTED_KEYS } from 'Containers/Scheduler/containers/utils/mobileDragHint';

export function clearSessionStoragePreservingFromApp() {
  const fromApp = !!localStorage.getItem('fromApp');
  const language = localStorage.getItem('i18nextLng');
  const salonCityCache = localStorage.getItem('salonCityCache');
  const persistKeys = [...HOME_PERSISTED_PROMO_KEYS, ...SCHEDULER_PERSISTED_KEYS];
  const persisted = persistKeys.map((key) => [key, localStorage.getItem(key)]);
  localStorage.clear();
  if (fromApp) {
    localStorage.setItem('fromApp', 'true');
  }
  if (language) {
    localStorage.setItem('i18nextLng', language);
  }
  if (salonCityCache) {
    localStorage.setItem('salonCityCache', salonCityCache);
  }
  persisted.forEach(([key, value]) => {
    if (value) localStorage.setItem(key, value);
  });
}
